var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2816_6263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.64764 0.99976C0.64764 0.807963 0.80555 0.652481 1.00034 0.652481L4.17464 0.652481C4.36944 0.652481 4.52735 0.807963 4.52735 0.99976C4.52734 1.19156 4.36944 1.34704 4.17464 1.34704H1.35304V4.12527C1.35304 4.31706 1.19513 4.47254 1.00034 4.47255C0.80555 4.47255 0.64764 4.31706 0.64764 4.12527L0.64764 0.99976ZM6.30273 6.22064L6.05334 6.46621L0.750944 1.24532L1.00034 0.99976L1.24974 0.754197L6.55213 5.97508L6.30273 6.22064Z",
    fill: "#0F3250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5156 0.999752C13.5156 0.807955 13.3577 0.652473 13.1629 0.652473L9.98856 0.652474C9.79377 0.652474 9.63586 0.807955 9.63586 0.999752C9.63586 1.19155 9.79377 1.34703 9.98856 1.34703H12.8102V4.12526C12.8102 4.31706 12.9681 4.47254 13.1629 4.47254C13.3577 4.47254 13.5156 4.31706 13.5156 4.12526L13.5156 0.999752ZM7.86047 6.22063L8.10987 6.4662L13.4123 1.24532L13.1629 0.999752L12.9135 0.754189L7.61108 5.97507L7.86047 6.22063Z",
    fill: "#0F3250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.64764 12.9999C0.64764 13.1917 0.80555 13.3472 1.00034 13.3472L4.17464 13.3472C4.36944 13.3472 4.52735 13.1917 4.52735 12.9999C4.52734 12.8081 4.36944 12.6527 4.17464 12.6527H1.35304V9.87443C1.35304 9.68263 1.19513 9.52715 1.00034 9.52715C0.80555 9.52715 0.64764 9.68263 0.64764 9.87443L0.64764 12.9999ZM6.30273 7.77905L6.05334 7.53349L0.750944 12.7544L1.00034 12.9999L1.24974 13.2455L6.55213 8.02462L6.30273 7.77905Z",
    fill: "#0F3250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1627 13.3472C13.3575 13.3472 13.5154 13.1917 13.5154 12.9999L13.5154 9.87443C13.5154 9.68263 13.3575 9.52715 13.1627 9.52715C12.968 9.52715 12.81 9.68263 12.81 9.87443V12.6527H9.98844C9.79365 12.6527 9.63574 12.8081 9.63574 12.9999C9.63574 13.1917 9.79365 13.3472 9.98844 13.3472L13.1627 13.3472ZM7.86035 7.77905L7.61095 8.02462L12.9133 13.2455L13.1627 12.9999L13.4121 12.7544L8.10975 7.53349L7.86035 7.77905Z",
    fill: "#0F3250"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2816_6263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 -0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSizer);
export default __webpack_public_path__ + "static/media/img-sizer.69ba186b7e4a91916fd2a097d2aa50bf.svg";
export { ForwardRef as ReactComponent };